<template>
  <div id="stepThree">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <!--
      <h2>Volunteer Scenarios</h2>
      <br/>
      <p>For the first time ever hybrid SIGGRAPH, Student Volunteers and Team Leaders are expected to serve the conference either in <b>virtual shifts (pre-conference)</b> or <b>in-person shifts (during conference)</b>. To facilitate logistics, a student volunteer or team leader will not be assigned to both types of shifts. </p>
      <p>Please indicate in order of preference the scenario(s) you are applying for:</p>
      <b-form-group label="First choice:" label-for="firstChoice">
        <multiselect :options="svTypePreferences" :value="getVolunteerTypePrefFirst" :searchable="false" :close-on-select="true" :allow-empty="true" :hide-selected="true" @input="updateFirstPreference"/>
      </b-form-group>
      <b-form-group label="Second choice:" label-for="secondChoice">
        <multiselect :options="svTypePreferencesSecond" :value="getVolunteerTypePrefSecond" :searchable="false" :close-on-select="true" :allow-empty="true" :hide-selected="true" @input="updateSecondPreference"/>
        <p>Select 'None’ if you can serve only in one type of role</p>
      </b-form-group>
      <div v-if="isVirtual">
        <h2>Time Zone - Virtual volunteers</h2>
        <br/>
        <ul style="list-style-type:square; padding-left: 15px">
          <li>Western North America - (UTC-9:00 to UTC-7:00)</li>
          <li>South America and Eastern North America - (UTC−06:00 to UTC−02:00)</li>
          <li>Europe and Western Africa - (UTC-01:00 to UTC+04:00)</li>
          <li>Western/Central Asia and East Africa - (UTC+4:00 to UTC+7:00)</li>
          <li>East Asia and Oceania - (UTC+08:00 to UTC−10:00)</li>
        </ul>
        <b-form-group label="In what time zone group will you be during the pre-conference shifts?" label-for="secondChoice">
          <multiselect :options="timeZones" :value="getTimeZone" :searchable="false" :close-on-select="true" :allow-empty="true" :hide-selected="true" @input="updateTimeZone"/>
        </b-form-group>
      </div>
      <br/>
      <div v-if="isInPerson">
        <h2>Other Information - In-person volunteers</h2>
        <b-form-group>
          <h3>T-Shirt Size</h3>
          <p>Every in-person Student Volunteer will be given 2 SV t-shirts at SV Check-In. It is mandatory to wear an SV t-shirt while on-shift.</p>
          <b-form-select id="shirtSize" v-model="shirtSize" :options="shirtSizes" class="mb-3">
          </b-form-select>
        </b-form-group>
        <b-form-group>
          <h3>Dietary Restrictions</h3>
          <p>Do you have any dietary restrictions?</p>
          <b-form-checkbox-group id="dietaryRestrictions" name="diet" v-model="diet" stacked :options="diets">
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-group>
          <label for="otherDiet">Other Dietary Restrictions</label>
          <b-form-input name="otherDiet" v-model="otherDiet" type="text"></b-form-input>
        </b-form-group>
        <br/>
        -->
        <h2>Financial Assistance</h2>
        <br/>
        <p>Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes through a blind jury process. It is not based on nationality or country/location of residence, anyone can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed. Travel assistance, if awarded, will be communicated upon acceptance.</p>
        <b-form-group>
          <b-form-checkbox id="financialAid" v-model="financialAid">
            I would like to apply for financial assistance
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Explain why you require financial assistance" label-for="financialAidSummary">
          <div class="row">
            <div class="col col-md-8">
              <b-form-textarea id="financialAidSummary" @input="wordCount('financialAidSummary', 80)" v-model="financialAidSummary" :rows="6" :max-rows="100"/>
              <p :class="financialAidSummaryWordLimitClass">{{ financialAidSummaryWordCount }}</p>
            </div>
          </div>
        </b-form-group>
        <!-- <b-form-group v-if="financialAid">
          <label for="roomPreference">If you receive lodging with fellow SVs during SIGGRAPH, what is your room preference?</label>
          <b-form-radio-group id="room-preference" v-model="roomPreference" name="roomPreference" stacked class="radio">
            <b-form-radio value="male">I prefer a males-only room</b-form-radio>
            <b-form-radio value="female">I prefer a females-only room</b-form-radio>
            <b-form-radio value="coed">I am open to both male and female/co-ed roommates</b-form-radio>
            <b-form-radio value="noPreference">I have no preference</b-form-radio>
          </b-form-radio-group>
        </b-form-group> -->
        <b-form-group v-if="financialAid" label="Provide a breakdown of your estimated travel expenses in US Dollars in a list format (travel, lodging, food, daily transportation to the conference, etc.)" label-for="financialAidExpenses">
          <div class="row">
            <div class="col col-md-8">
              <b-form-textarea id="financialAidExpenses" @input="wordCount('financialAidExpenses', 30)" v-model="financialAidExpenses" :rows="6" :max-rows="100"/>
              <p :class="financialAidExpensesWordLimitClass">{{ financialAidExpensesWordCount }}</p>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Provide an estimate of your total travel expenses in US Dollars (sum of the breakdown you previously provided)" label-for="estimatedTravelCost">
          <b-form-input type="text" v-model="estimatedTravelCost" id="estimatedTravelCost"></b-form-input>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Primary Mode of Transportation to the Conference's City" label-for="primaryTransport">
          <b-form-select id="primaryTransport" v-model="primaryTransport" :options="primaryTransportList" class="mb-3"/>
        </b-form-group>
        <b-form-group v-if="financialAidAndFlying" label="If Flying, 3-letter Code for Nearest Airport" label-for="airportCode">
          <div class="row">
            <div class="col col-md-2">
              <b-form-input type="text" v-model="airportCode" id="airportCode"></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid">
          <b-form-checkbox id="fundedTravel" v-model="fundedTravel">
            Funding for my travel will be fully or partially covered by outside sources (such as university funding, etc.).
          </b-form-checkbox>
        </b-form-group>
        <br/>
  <!--</div>-->
      <h2>Team Leader Questions</h2>
      <br/>
      <p v-if="pastTLAppDeadline">The deadline for Team Leader applications has passed</p>
      <div v-else>
        <p>Only SIGGRAPH Student Volunteers with at least 1 year of prior SV experience are eligible for Team Leader positions. Team Leaders (TLs) are Student Volunteers (SVs) selected to serve as liaisons to Venue and Program Chairs across the different areas of the conference.</p>
        <p>TLs have more responsibility and a more demanding workload than a regular SV. TLs serve in a supervisory role as they help train SVs to perform different duties, and resolve more complex attendee, contributor and volunteer questions and issues. TLs also volunteer approximately 60 hours either in pre-conference shifts or during the SIGGRAPH  week in addition to several pre-conference training sessions.</p>
        <p>Please keep in mind the TL application process is very competitive. TL applicants not selected for the role will still be considered for a position as SV.</p>
      </div>
      <b-form-group>
        <b-form-checkbox id="teamLeader" v-model="teamLeader" :disabled="pastTLAppDeadline">
          I would like to apply for a Team Leader position
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="teamLeader" label="Tell us about your motivation to be a Team Leader." label-for="teamLeaderEssay1">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="teamLeaderEssay1" @input="wordCount('teamLeaderEssay1', 250)" v-model="teamLeaderEssay1" :rows="6" :max-rows="100"/>
            <p :class="teamLeaderEssay1WordLimitClass">{{ teamLeaderEssay1WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <b-form-group v-if="teamLeader" label="Tell us about the qualities and experiences that make you a great fit for the role. Include any relevant leadership and/or mentorship experience." label-for="teamLeaderEssay2">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="teamLeaderEssay2" @input="wordCount('teamLeaderEssay2', 250)" v-model="teamLeaderEssay2" :rows="6" :max-rows="100"/>
            <p :class="teamLeaderEssay2WordLimitClass">{{ teamLeaderEssay2WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h2>Additional Comments</h2>
      <br/>
      <b-form-group label="Is there anything else you'd like the Student Volunteer Subcomittee to know?" label-for="otherComments">
        <div class="row">
          <div class="col col-md-8">
            <b-form-textarea id="otherComments" v-model="otherComments" :rows="6" :max-rows="100"/>
          </div>
        </div>
      </b-form-group>
      <br/>
      <b-form-group>
        <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep">Previous Step</button>
        <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep">Save and Continue</button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { primaryTransportList, timeZones } from '@/util/SelectLists'
import { mapState, mapGetters } from 'vuex'
import router from '@/router'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepThree',
  data () {
    return {
      // svTypePreferences: svTypePreferences,
      // svTypePreferencesSecond: svTypePreferencesSecond,
      primaryTransportList: primaryTransportList,
      financialAidSummaryWordCount: '80 words remaining',
      financialAidSummaryWordLimitClass: 'under-limit',
      financialAidExpensesWordCount: '30 words remaining',
      financialAidExpensesWordLimitClass: 'under-limit',
      teamLeaderEssay1WordCount: '250 words remaining',
      teamLeaderEssay1WordLimitClass: 'under-limit',
      teamLeaderEssay2WordCount: '250 words remaining',
      teamLeaderEssay2WordLimitClass: 'under-limit',
      disabled: false,
      // shirtSizes: shirtSizes,
      // diets: diets,
      timeZones: timeZones
    }
  },
  computed: {
    ...generateVuexSetters([
      'financialAidSummary',
      'primaryTransport',
      'airportCode',
      'financialAidExpenses',
      'estimatedTravelCost',
      'roomPreference',
      'fundedTravel',
      'fundedTravel',
      'teamLeaderEssay1',
      'teamLeaderEssay2',
      'otherComments',
      'firstChoice',
      'secondChoice'
      // 'shirtSize',
      // 'diet',
      // 'otherDiet'
    ]),
    financialAid: {
      get () {
        return this.$store.state.application.financialAid
      },
      set (value) {
        this.$store.commit('application/updateFinancialAid', value)
      }
    },
    teamLeader: {
      get () {
        return this.$store.state.application.teamLeader
      },
      set (value) {
        this.$store.commit('application/updateTeamLeader', value)
      }
    },
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapGetters('application', ['financialAidAndFlying', 'getVolunteerTypePrefFirst', 'getVolunteerTypePrefSecond', 'getTimeZone']),
    ...mapGetters(['pastTLAppDeadline']),
    isInPerson: function () {
      return this.firstChoice === 'In-person' || this.secondChoice === 'In-person'
    },
    isVirtual: function () {
      return this.firstChoice === 'Virtual' || this.secondChoice === 'Virtual'
    }
  },
  methods: {
    updateTimeZone (value) {
      this.$store.commit('application/updateField', { name: 'timeZone', value: value })
    },
    updateFirstPreference (value) {
      if (this.secondChoice === value) {
        this.$store.commit('application/updateField', { name: 'secondChoice', value: '' })
      }
      this.$store.commit('application/updateField', { name: 'firstChoice', value: value })
    },
    updateSecondPreference (value) {
      if (this.firstChoice === value) {
        this.$store.commit('application/updateField', { name: 'firstChoice', value: '' })
      }
      this.$store.commit('application/updateField', { name: 'secondChoice', value: value })
    },
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 4)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepFour' })
          window.scrollTo(0, 0)
          this.disabled = true
        }).catch(err => {
          console.log(err.message)
          this.disabled = true
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 2)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepTwo' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 3) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('teamLeaderEssay1', 250)
    this.wordCount('teamLeaderEssay2', 250)
    this.wordCount('financialAidExpenses', 30)
    this.wordCount('financialAidSummary', 80)
  },
  components: {
    multiselect: Multiselect
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/application/StepThree.vue